/**
 * @title link-membership.js: Sub-module for Product Details page
 * @description This sub-module is used to handle membership validation.
 * @dependency checkout_helper.js
 */
define(['checkout_helper'], function(checkoutHelper) {
  let LinkMembership = {

    /**
     * Constants.
     */
    constants: {
      PRIMARY_VALIDATION_FORM_ID: '#membership-primary-validation-form',
      PRIMARY_VALIDATION_FORM_NAME: 'membershipPrimaryValidationForm',
      SECONDARY_VALIDATION_FORM_ID: '#membership-secondary-validation-form',
      ERROR_PLACEHOLDER_ID: '#error-placeholder',
      AJAX_LOADER_ID: '#link-membership-loader',
      SECONDARY_VALIDATION_VIEW: '/MembershipSecondaryValidationView',
      CANCELED_MEMBERSHIP_VIEW: '/CanceledMembershipView',
    },

    /**
     * Object that holds useful membership data.
     */
    memberData: {
      number: '',
    },

    /**
     * Initialization function.
     */
    init: function() {
      // 'Link Membership' button visibility is toggled in CMath.init() which executes prior to this call.
      if ($('#link-membership, #link-membership-v2, .link-membership-btn, .link-membership-pet-meds').is(':visible')) {
        $('#link-membership, #link-membership-v2, .link-membership-btn, #link-membership-for-price').unbind('click').click(function() {
          COSTCO.LinkMembership.openLinkMembershipModal();
        });
        
        COSTCO.LinkMembership.populateMemberData();
        COSTCO.LinkMembership.addValidationRules();
      }
      if ($('#ProductForm [name=purchase-membership]').is(':visible')) {
      	$('#ProductForm [name=purchase-membership]').unbind('click').click(function() {
      		COSTCO.LinkMembership.purchaseMembershipButtonClick();
      	});
      }

      console.log('Link Membership sub-module initialized.');
    },

    /**
     * Populates this.memberData using the membershipNumber derived from
     * wcMember persistent cookie.
     */
    populateMemberData: function() {
      this.memberData.number = COSTCO.util.getMemberCookie().membershipNumber;
    },

    /**
     * Mask employee start date
     */
    maskStartDateInput: function() {
      $('#employeeStartDate').mask('00/00', {
        placeholder: 'MM/YY',
      });
    },

    /**
     * Opens 'Link Membership for Price' dialog modal.
     */
  
    openLinkMembershipModal: function(title) {

      var modalTitle = (typeof title === 'undefined') ? messages.MEMBERSHIP_VALIDATION_LinkMembershipForPriceModal_Title : title;

      let bypassEnabled = typeof memberValidationBypassFeatureEnabled !== "undefined" && memberValidationBypassFeatureEnabled === true;
      let modalSettings = {
        dialogclasses: 'link-membership-modal',

        title: bypassEnabled 
        	? messages.RWD_ADD_MEMBERSHIP_NUMBER 
        	: modalTitle,
        body: COSTCO.util.tmpl('tmpl_membership_validation_pdp', {
          infoText: bypassEnabled 
          	? messages.MEMBERSHIP_VALIDATION_LinkMembershipForPriceStep1Modal_Body_InfoText_ALT
          	: messages.MEMBERSHIP_VALIDATION_LinkMembershipForPriceStep1Modal_Body_InfoText,
          membershipNumber: COSTCO.LinkMembership.memberData.number,
        }),
        
        primary: bypassEnabled 
        	? messages.RWD_ADD_MEMBERSHIP_NUMBER 
        	: messages.MEMBERSHIP_VALIDATION_LinkMembershipForPriceModal_Continue_ButtonText,
        secondary: messages.JS_DIALOG_CANCEL,
        primary_event: this.performPrimaryValidation,
        preventClose: false,
        onshown: function() {
          $('.modal-header, .modal-body, .modal-footer').addClass('order-ajax');
          COSTCO.util.maskMembershipInput();
          $('.co-help').popover();
        },
        onclose: function() {},
      };

      COSTCO.dialog.showModal(modalSettings);
    },
    /**
     * Executes logic on Purchase Membership button click on PDP page.
     */
    purchaseMembershipButtonClick: function() {
    	if ($.cookie('cartCountCookie') > 0) {
            window.open('/join-costco.html?COSTID=Header_Membership_TOP', '_self');
          } else {
            window.open('/join-costco-quick.html?COSTID=Header_Membership_TOP', '_self');
          }
    },
    /**
     * Validation rules for the inputs associated with creating an account.
     */
    addValidationRules: function() {
      $.validator.addMethod('costcoMembership', function(value, element) {
        return /^\d{12,16}$/.test(value);
      }, messages.ERR_INVALID_MEMBERSHIP_NO);
    },

    /**
     * Validates the primary validation form.
     * @param {Object} $primaryValidationForm - Form to be validated.
     */
    validatePrimaryValidationForm: function($primaryValidationForm) {
      $primaryValidationForm.validate({

        ignoreTitle: true,

        rules: {
          membershipId: {
            required: true,
            costcoMembership: true,
          },
          lastName: {
            // Last name is not required, i.e. for internal membership
            // required: true,
          },
        },

        messages: {
          membershipId: {
            required: messages.JS_VALID_REQUIRED,
            costcoMembership: messages.ERR_INVALID_MEMBERSHIP_NO,
          },
          lastName: {
            required: messages.JS_VALID_REQUIRED,
          },
        },
        highlight: COSTCO.util.highlightWithErrorLabel,
        unhighlight: COSTCO.util.unhighlightWithErrorLabel
      });
    },

    /**
     * Performs primary validation of entered data via calling Ajax Modular command.
     */
    performPrimaryValidation: function() {
      let $primaryValidationForm = $(COSTCO.LinkMembership.constants.PRIMARY_VALIDATION_FORM_ID);

      COSTCO.LinkMembership.validatePrimaryValidationForm($primaryValidationForm);

      if ($primaryValidationForm.valid()) {
        COSTCO.LinkMembership.clearErrors();
        COSTCO.LinkMembership.ajaxLoader.on();
        checkoutHelper.ajax_update_state({
          method: 'POST',
          url: '/AjaxMembershipPrimaryValidationCmd',
          data: $primaryValidationForm.serialize(),
          dataType: 'json',
          done: function(data, textStatus, jqXHR, options) {
            // COSTCO.LinkMembership.clearErrors();
            COSTCO.LinkMembership.ajaxLoader.off();
            if (data.payload.data.status == 'success') {
              COSTCO.LinkMembership.memberData.number = $(COSTCO.LinkMembership.constants.PRIMARY_VALIDATION_FORM_ID + ' :input[name=membershipId]').val().trim();
              if (data.payload.data.validationCompleted) {
                COSTCO.dialog.close();
                location.reload();
              } else {
                checkoutHelper.ajax_update_default_done(data, textStatus, jqXHR, options);
                COSTCO.LinkMembership.maskStartDateInput();
                $('#costcoModalBtn2').html(messages.LINK_MEMBERSHIP_BUTTON);
                $('#costcoModalBtn2').unbind('click').bind('click', COSTCO.LinkMembership.performSecondaryValidation);
                if ($('#error-placeholder').data('status') == 'undetermined') {
                  $('#costcoModalBtn2').unbind('click');
                  $('#costcoModalBtn2').prop('disabled', true);
                }
              }
            } else if (data.error.application.length > 0) {
              let errorCode = data.payload.data.errorCode;
              // Expired Membership
              if (errorCode == 'E53') {
                window.location.href = LinkMembership.constants.SECONDARY_VALIDATION_VIEW;
                // Canceled Membership
              } else if (errorCode == 'E54') {
                let canceledMembershipNumber = data.payload.data.membershipId ? data.payload.data.membershipId : '';
                let membershipStatusReason = data.payload.data.membershipStatusReason ? data.payload.data.membershipStatusReason : '';
                let membership_membershipType = data.payload.data.membership_membershipType ? data.payload.data.membership_membershipType : '';
                let isLostOrStolenCard = data.payload.data.isLostOrStolenCard ? data.payload.data.isLostOrStolenCard : '';
                $form = $('form[name=' + LinkMembership.constants.PRIMARY_VALIDATION_FORM_NAME + ']');
                $form.append('<input type="hidden" name="canceledMembershipNumber" value="' + canceledMembershipNumber + '">');
                $form.append('<input type="hidden" name="membershipStatusReason" value="' + membershipStatusReason + '">');
                $form.append('<input type="hidden" name="membership_membershipType" value="' + membership_membershipType + '">');
                $form.append('<input type="hidden" name="isLostOrStolenCard" value="' + isLostOrStolenCard + '">');
                $form.append('<input type="hidden" name="isReturningUser" value="true">');
                $form.attr('action', LinkMembership.constants.CANCELED_MEMBERSHIP_VIEW);
                $form.submit();
              } else {
                // Override this particular error message with the post-lockdown one; Remove as redundant in post-lockdown phase.
                if (errorCode == 'E07') {
                  data.error.application = [];
                  data.error.application.push(messages._ERR_MEMBERSHIP_PRIMARY_VALIDATION_MEMBERSHIP_ID_POSTLOCKDOWN);
                }
                COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, data.error.application, false, COSTCO.LinkMembership.constants.ERROR_PLACEHOLDER_ID);
                COSTCO.LinkMembership.markErrorFields(errorCode);
              }
            } else {
              COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, ['Unexpected error occurred.'], false, COSTCO.LinkMembership.constants.ERROR_PLACEHOLDER_ID);
              console.error('Unexpected error occurred.');
            }
          },
          always: function() {
            COSTCO.LinkMembership.ajaxLoader.off();
            $('.order-ajax').removeClass('ajax-busy');
          },
        });
      }
    },

    /**
     * Performs secondary validation of entered data via calling Ajax Modular command.
     */
    performSecondaryValidation: function() {
      let $secondaryValidationForm = $(COSTCO.LinkMembership.constants.SECONDARY_VALIDATION_FORM_ID);
      let action = $secondaryValidationForm.find('input[name=action]').val();
      // If we're validating the employee primary first and last name, we set
      // the users answer to a combination of these with a pipe.
      if (action == 'employee_first_last_name') {
        let firstName = $secondaryValidationForm.find('[name="usersFirstNameAnswer"]').val();
        let lastName = $secondaryValidationForm.find('[name="usersLastNameAnswer"]').val();
        $('#usersAnswer').val(`${firstName}|${lastName}`);
      }

      COSTCO.LinkMembership.ajaxLoader.on();

      checkoutHelper.ajax_update_state({
        method: 'POST',
        url: '/AjaxMembershipSecondaryValidationCmd',
        data: $secondaryValidationForm.serialize(),
        dataType: 'json',
        done: function(data, textStatus, jqXHR, options) {
          COSTCO.LinkMembership.ajaxLoader.off();
          COSTCO.LinkMembership.clearErrors();
          if (data.status == 'success') {
            COSTCO.dialog.close();
            location.reload();
          } else if (data.message) {
            // TODO: Is there a better way to handle '&lt;' and '&gt;' from response?
            data.message = data.message.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
            COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, [data.message], false, COSTCO.LinkMembership.constants.ERROR_PLACEHOLDER_ID);
          } else {
            COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, ['Unexpected error occurred.'], false, COSTCO.LinkMembership.constants.ERROR_PLACEHOLDER_ID);
            console.error('Unexpected error occurred.');
          }
        },
        always: function() {
          COSTCO.LinkMembership.ajaxLoader.off();
          $('.order-ajax').removeClass('ajax-busy');
        },
      });
    },

    /**
     * Marks input fields with class 'validation-error' depending on error code.
     * @param {string} errorCode
     */
    markErrorFields: function(errorCode) {
      if (['E01', 'E02', 'E03', 'E04', 'E07', 'E51'].indexOf(errorCode) > -1) {
        $('input[name=membershipId]').addClass('validation-error');
      }

      if (['E01', 'E02', 'E03', 'E52'].indexOf(errorCode) > -1) {
        $('input[name=lastName]').addClass('validation-error');
      }

      if (errorCode == 'unknown') {
        console.error('Uknnown error code.');
      }

      $('input.validation-error:first').focus();
    },

    /**
     * Clears error notification box and removes validation-error class from input fields.
     */
    clearErrors: function() {
      COSTCO.util.notification.clearNotification(COSTCO.LinkMembership.constants.ERROR_PLACEHOLDER_ID);
      $('input.validation-error').removeClass('validation-error');
    },

    /**
     * Turn AJAX loader on/off and disable/enable clicking appropriately.
     */
    ajaxLoader: {
      on: function() {
        $(COSTCO.LinkMembership.constants.AJAX_LOADER_ID).show();
        $('body').css('pointer-events', 'none');
      },
      off: function() {
        $(COSTCO.LinkMembership.constants.AJAX_LOADER_ID).hide();
        $('body').css('pointer-events', 'auto');
      },
    },
  };

  if (typeof window.COSTCO === 'undefined') {
    window.COSTCO = {};
  }

  window.COSTCO.LinkMembership = LinkMembership;

  return LinkMembership;
});



// WEBPACK FOOTER //
// ./js/product/link-membership.js